import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropdown", "content", "container"]
  static values = { 
    open: { type: Boolean, default: false }
  }

  connect() {
    // Listen for close events from other dropdowns
    this.element.addEventListener('dropdown:close', this.closeDropdown.bind(this))
  }

  disconnect() {
    this.element.removeEventListener('dropdown:close', this.closeDropdown.bind(this))
  }

  toggle() {
    if (this.openValue) {
      this.closeDropdown()
    } else {
      // Close all other dropdowns first
      this.closeAllOtherDropdowns()
      this.openDropdown()
    }
  }

  closeAllOtherDropdowns() {
    // Find all dropdown controllers on the page
    const allDropdowns = document.querySelectorAll('[data-controller*="dropdown"]')
    
    allDropdowns.forEach(dropdown => {
      // Skip the current dropdown
      if (dropdown === this.element) return
      
      // Check if this dropdown has the open value set to true
      const isOpen = dropdown.getAttribute('data-dropdown-open-value') === 'true'
      if (isOpen) {
        // Trigger close on other open dropdowns
        const event = new CustomEvent('dropdown:close')
        dropdown.dispatchEvent(event)
      }
    })
  }

  openDropdown() {
    this.openValue = true
    this.dropdownTarget.style.gridTemplateRows = "1fr"
    this.dropdownTarget.classList.add("open")
    // Add gap when opening
    this.containerTarget.classList.add("gap-2")
  }

  closeDropdown() {
    this.openValue = false
    this.dropdownTarget.style.gridTemplateRows = "0fr"
    this.dropdownTarget.classList.remove("open")
    // Remove gap when closing
    this.containerTarget.classList.remove("gap-2")
    this.containerTarget.classList.add("gap-0")
  }
}
